<template>
  <div>
      <DesktopInside></DesktopInside>
  </div>
</template>

<script>
import DesktopInside from '@/components/DesktopInside';

export default {
  components: {
    DesktopInside,
  },
};
</script>
